import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import {
  DataListProvider,
  type UseDataListProps,
  useDataList,
} from '../../../data-list/use-data-list.ts'
import { useCardContext } from '../../use-card.ts'
import { CardDetailsCompactAvatar } from './card-details-compact-avatar.tsx'
import {
  CardDetailsCompactItem,
  CardDetailsCompactItemDescription,
  CardDetailsCompactItemTitle,
} from './card-details-compact-item.tsx'

export type CardDetailsMiniProps = PropsWithChildren<
  UseDataListProps & {
    className?: string
  }
>
export const CardDetailsCompactComponent = ({
  children,
  className,
  fontSize = 'sm',
  variant = 'subtle',
}: CardDetailsMiniProps) => {
  const { scale } = useCardContext()
  const context = useDataList({ fontSize, variant })

  return scale === 'sm' ? null : (
    <DataListProvider value={context}>
      <div className={cn('flex gap-x-4 items-center', className)}>
        {children}
      </div>
    </DataListProvider>
  )
}

const CardDetailsCompactNamespace = Object.assign(CardDetailsCompactComponent, {
  AvatarItem: CardDetailsCompactAvatar,
  DataItem: CardDetailsCompactItem,
  DataItemTitle: CardDetailsCompactItemTitle,
  DataItemDescription: CardDetailsCompactItemDescription,
})

export { CardDetailsCompactNamespace as CardDetailsCompact }
